import { render, staticRenderFns } from "./ImpactQmsRequirementProposal.vue?vue&type=template&id=267350e8&scoped=true&"
import script from "./ImpactQmsRequirementProposal.vue?vue&type=script&lang=ts&"
export * from "./ImpactQmsRequirementProposal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267350e8",
  null
  
)

export default component.exports